import { __assign } from "tslib";
import React from "react";
import ReactSelect from "react-select";
import { SelectContainer, Title } from "./styles";
import { hexToRgb } from "../../../utils/functions";
var DefaultSelect = function (_a) {
    var name = _a.name, label = _a.label, labelStyles = _a.labelStyles, options = _a.options, placeholder = _a.placeholder, onChange = _a.onChange, value = _a.value, menuIndex = _a.menuIndex, containerStyles = _a.containerStyles, controlStyles = _a.controlStyles, defaultValue = _a.defaultValue, customColor = _a.customColor, disabled = _a.disabled;
    var hexColor = hexToRgb(customColor);
    var colourStyles = {
        control: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: disabled ? "#f4f4f4" : "white" })); },
        option: function (styles, _a) {
            var isDisabled = _a.isDisabled, isFocused = _a.isFocused, isSelected = _a.isSelected;
            return __assign(__assign({}, styles), { backgroundColor: isDisabled
                    ? undefined
                    : isSelected
                        ? hexColor.normal
                        : isFocused
                            ? hexColor.hover
                            : undefined, color: isDisabled ? "#ccc" : isSelected, cursor: isDisabled ? "not-allowed" : "default", ":active": __assign(__assign({}, styles[":active"]), { backgroundColor: !isDisabled
                        ? isSelected
                            ? hexColor.normal
                            : hexColor.hover
                        : undefined }) });
        },
        input: function (styles) { return (__assign({}, styles)); },
        placeholder: function (styles) { return (__assign({}, styles)); },
        singleValue: function (styles) { return (__assign({}, styles)); }
    };
    return (React.createElement(SelectContainer, { style: containerStyles, menuIndex: menuIndex, controlStyles: controlStyles },
        label && React.createElement(Title, { style: labelStyles }, label),
        React.createElement(ReactSelect, { name: name, defaultValue: defaultValue, placeholder: placeholder || "Selecionar", options: options, theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary25: hexColor.hover, primary: "transparent" }) })); }, value: value, styles: colourStyles, onChange: onChange, isDisabled: disabled })));
};
DefaultSelect.defaultProps = {
    label: undefined,
    labelStyles: undefined,
    placeholder: undefined,
    onChange: function () { },
    value: undefined,
    menuIndex: 0,
    containerStyles: undefined,
    controlStyles: undefined,
    defaultValue: undefined,
    customColor: "#FFB7BE"
};
export default DefaultSelect;
//# sourceMappingURL=index.js.map